import { fabric } from 'fabric';
import { isMobile } from '@/helpers/mobile_detect';

const STATE_PAN_UNAVAILABLE = 'unavailable';
const STATE_PAN_AVAILABLE = 'available';
const STATE_PAN_PENDING = 'pending';
const STATE_PAN_PANNING = 'panning';

export default fabric.util.createClass(fabric.Canvas, {
  initialize(name, { maxZoom, isEditable }, options) {
    this.callSuper('initialize', name, options);

    this.backgroundColor = '#fafafa';
    this.panState = STATE_PAN_UNAVAILABLE;
    this.maxZoom = maxZoom;
    this.isEditable = isEditable;

    this.lastPanPosition = null;

    if (this.map.isScrollZoomable) {
      this.on('mouse:wheel', this._handleMouseWheel);
    }

    this
      .on('mouse:down', this._handleMouseDown)
      .on('mouse:up', this._handleMouseUp)
      .on('mouse:move', this._handleMouseMove)
      .on('object:moving', this._restrictMovingOutside);

    if (isMobile() && !this.isEditable) {
      this.initialTouchZoomDistance = null;
      this.initialTouchZoom = null;

      this
        .on('mouse:up', this._handleMobileMouseUp)
        .on('mouse:move', this._handleMobileMouseMove);
    }
  },
  applyZoom(zoomPoint, newZoom) {
    const zoom = this._limitZoom(newZoom);

    if (zoom === 1) {
      this.setViewportTransform([1, 0, 0, 1, 0, 0]);
      this._disallowPannig();
      this.fire('canvas:zoom');
      return;
    }

    this._allowPannig();

    if (zoomPoint) {
      this.zoomToPoint(zoomPoint, zoom);
      this.fire('canvas:zoom');
      return;
    }

    const prevZoom = this.getZoom();
    const halfWidth = this.width / 2;
    const halfHeight = this.height / 2;
    const ratio = newZoom / prevZoom;

    const viewportTransform = [...this.viewportTransform];
    viewportTransform[4] = halfWidth - ratio * (halfWidth - viewportTransform[4]);
    viewportTransform[5] = halfHeight - ratio * (halfHeight - viewportTransform[5]);
    viewportTransform[0] = newZoom;
    viewportTransform[3] = newZoom;

    this.setViewportTransform(viewportTransform);

    this.fire('canvas:zoom');
    this.requestRenderAll();
  },
  applyPan(newPosition) {
    if (this.lastPanPosition) {
      const delta = {
        x: newPosition.x - this.lastPanPosition.x,
        y: newPosition.y - this.lastPanPosition.y
      };

      this.viewportTransform[4] += delta.x;
      this.viewportTransform[5] += delta.y;

      this.requestRenderAll();
      // this.renderAll();
    }
    this.lastPanPosition = newPosition;
  },
  _allowPannig() {
    this.panState = STATE_PAN_AVAILABLE;

    if (this.defaultCursor !== 'move') {
      this.defaultCursor = 'move';
      this.requestRenderAll();
    }
  },
  _disallowPannig() {
    this._stopPanning();

    this.panState = STATE_PAN_UNAVAILABLE;
    this.defaultCursor = 'default';
  },
  _preparePanning() {
    this.panState = STATE_PAN_PENDING;
  },
  _unpreparePanning() {
    this.panState = STATE_PAN_AVAILABLE;
  },
  _startPanning() {
    this.panState = STATE_PAN_PANNING;

    this.forEachObject(object => {
      object.prevEvented = object.evented;
      object.prevSelectable = object.selectable;
      object.evented = false;
      object.selectable = false;
    });

    this.prevSelection = this.selection;
    this.selection = false;

    this.requestRenderAll();
  },
  _stopPanning() {
    this.panState = STATE_PAN_AVAILABLE;
    this.lastPanPosition = null;

    this.forEachObject(object => {
      object.evented = object.prevEvented !== undefined ?
        object.prevEvented :
        object.evented;
      object.selectable = object.prevSelectable !== undefined ?
        object.prevSelectable :
        object.selectable;

      object.setCoords(); // without it hover events won't work properly
    });

    this.selection = this.prevSelection;

    this.requestRenderAll();
  },
  _restrictMovingOutside({ target }) {
    if (target.angle) {
      return;
    }

    const edgeDetection = 10;
    target.setCoords(); // Sets corner position coordinates based on current angle, width and height
    const rect = target.getBoundingRect();

    if (rect.height > target.canvas.height * 0.75 ||
        target.currentWidth > target.canvas.width * 0.75
    ) {
      return;
    }

    if (rect.left < edgeDetection) {
      target.left = 0;
    }
    if (rect.top < edgeDetection) {
      target.top = 0;
    }
    if (rect.top + rect.height > target.canvas.height - edgeDetection) {
      target.top = target.canvas.height - rect.height;
    }
    if (rect.left + rect.width > target.canvas.width - edgeDetection) {
      target.left = target.anvas.width - rect.width;
    }
  },
  _limitZoom(zoom) {
    if (zoom > this.maxZoom) return this.maxZoom;
    if (zoom < 1) return 1;

    return zoom;
  },

  // mobile
  _handleSingleTouch(touch) {
    this.applyPan(touch);
  },
  _handleDoubleTouch(touch1, touch2) {
    const currentDistance = this._getTouchDistance(touch1, touch2);

    if (this.initialTouchZoomDistance && this.initialTouchZoom) {
      const scale = currentDistance / this.initialTouchZoomDistance;
      const zoomPoint = this._calculateZoomPoint(touch1, touch2);
      this.applyZoom(zoomPoint, this.initialTouchZoom * scale);
    }

    this.initialTouchZoomDistance = currentDistance;
    this.initialTouchZoom = this.getZoom();
  },
  _resetTouchZoomState() {
    this.initialTouchZoomDistance = null;
    this.initialTouchZoom = null;
  },
  _getTouchDistance(touch1, touch2) {
    return Math.sqrt(
      Math.pow(touch1.x - touch2.x, 2) + Math.pow(touch1.y - touch2.y, 2)
    );
  },
  _calculateZoomPoint(touch1, touch2) {
    const centerX = (touch1.x + touch2.x) / 2;
    const centerY = (touch1.y + touch2.y) / 2;

    const rect = this.getElement().getBoundingClientRect();
    const xRatio = this.width / rect.width;
    const yRatio = this.height / rect.height;

    return {
      x: (centerX - rect.left) * xRatio,
      y: (centerY - rect.top) * yRatio
    };
  },

  // events
  _handleMouseWheel({ e }) {
    e.preventDefault();
    e.stopPropagation();

    const delta = -e.deltaY;
    let zoom = this.getZoom();
    zoom += delta / 200;

    this.applyZoom({ x: e.offsetX, y: e.offsetY }, zoom);
  },
  _handleMouseDown() {
    if (this.panState === STATE_PAN_AVAILABLE) {
      if (!this.getActiveObject()) {
        this._preparePanning();
      }
    }
  },
  _handleMouseUp({ e }) {
    if (this.panState === STATE_PAN_PENDING) {
      this._unpreparePanning();
      return;
    }
    if (this.panState === STATE_PAN_PANNING) {
      this._stopPanning();
    }
    if (e.type === 'touchend') {
      this._resetTouchZoomState();
    }
  },
  _handleMouseMove({ e }) {
    if (this.panState === STATE_PAN_PENDING) {
      this._startPanning();
    }
    if (this.panState !== STATE_PAN_PANNING) { return; }
    if (isMobile() && e.touches?.length) { return; }

    this.applyPan({ x: e.clientX, y: e.clientY });
  },

  // touch events
  _handleMobileMouseUp({ e }) {
    if (e.type === 'touchend') {
      this._resetTouchZoomState();
    }
  },
  _handleMobileMouseMove({ e }) {
    const touchCount = e.touches?.length;

    if (touchCount === 1) {
      if (this.panState !== STATE_PAN_PANNING) { return; }
      this._handleSingleTouch(
        { x: e.touches[0].clientX, y: e.touches[0].clientY }
      );
    } else if (touchCount === 2) {
      this._handleDoubleTouch(
        { x: e.touches[0].clientX, y: e.touches[0].clientY },
        { x: e.touches[1].clientX, y: e.touches[1].clientY }
      );
    }
  }
});
